export const sanitizePappersName = (value: string) =>
  value
    .trim()
    .split(/[\s,]+/)
    .filter(Boolean)
    .map((part) =>
      part
        .split("-")
        .map((segment) => {
          const lower = segment.toLocaleLowerCase("fr");
          const first = lower[0];
          if (!first) return "";
          return first.toLocaleUpperCase("fr") + lower.slice(1);
        })
        .join("-"),
    )
    .join(" ");

export const pappersPersonName = (person: {
  nom?: string | null;
  prenom?: string | null;
  prenoms?: string | null;
}) => {
  const givenNames = sanitizePappersName(person.prenom || person.prenoms || "").split(" ");
  return {
    firstname: givenNames[0] ?? "",
    middleNames: givenNames.slice(1).join(" "),
    lastname: sanitizePappersName(person.nom ?? ""),
  };
};

const cleanPersonName = (value: string) =>
  value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/['’‘,.-]/g, " ")
    .toLowerCase()
    .replace(/[^a-z\s]/g, "")
    .trim()
    .replace(/\s+/g, " ");

/**
 * Stable id for a natural person. Undefined for companies and empty names.
 * Officers list every given name ("Grégoire, Pierre, Maurice, Marie"); beneficial owners
 * often list only the first. The key uses that first given name.
 */
export const pappersPersonKey = (person: {
  nom?: string | null;
  prenom?: string | null;
  prenoms?: string | null;
  personne_morale?: boolean | null;
}) => {
  if (person.personne_morale) return;
  const lastname = cleanPersonName(person.nom ?? "");
  const firstname = cleanPersonName(person.prenom || person.prenoms || "").split(" ")[0] ?? "";
  if (!lastname && !firstname) return;
  return `${lastname}|${firstname}`;
};
